__turbopack_context__.v({
  "active": "page-module-scss-module__0qz9ZW__active",
  "configurator": "page-module-scss-module__0qz9ZW__configurator",
  "content": "page-module-scss-module__0qz9ZW__content",
  "error": "page-module-scss-module__0qz9ZW__error",
  "intro": "page-module-scss-module__0qz9ZW__intro",
  "note": "page-module-scss-module__0qz9ZW__note",
  "option": "page-module-scss-module__0qz9ZW__option",
  "optionFlavor": "page-module-scss-module__0qz9ZW__optionFlavor",
  "optionName": "page-module-scss-module__0qz9ZW__optionName",
  "options": "page-module-scss-module__0qz9ZW__options",
  "shippingIncluded": "page-module-scss-module__0qz9ZW__shippingIncluded",
  "sizeBtn": "page-module-scss-module__0qz9ZW__sizeBtn",
  "sizeLabel": "page-module-scss-module__0qz9ZW__sizeLabel",
  "sizePrice": "page-module-scss-module__0qz9ZW__sizePrice",
  "sizes": "page-module-scss-module__0qz9ZW__sizes",
  "step": "page-module-scss-module__0qz9ZW__step",
  "subscribe": "page-module-scss-module__0qz9ZW__subscribe",
  "subscription": "page-module-scss-module__0qz9ZW__subscription",
  "summary": "page-module-scss-module__0qz9ZW__summary",
  "summaryPrice": "page-module-scss-module__0qz9ZW__summaryPrice",
  "summaryProduct": "page-module-scss-module__0qz9ZW__summaryProduct",
  "summarySize": "page-module-scss-module__0qz9ZW__summarySize",
  "title": "page-module-scss-module__0qz9ZW__title",
});
